<div *ngIf="
    (product.estoque > 0 || !validaEstoque) &&
    pedidoService.pedido &&
    pedidoService.pedido.clientes.length === 1
  ">

  <!-- QUANDO TEM SKU -->
  <div *ngIf="product.sku; else semSku"
       class="d-flex mt-1 mb-1 align-items-center"
       [style.padding]="'0 10%'">

    <div class="input-group flex-grow-1" style="padding-left: 0px;">
      <a class="noselect quantity-button-minus {{ inputClass }}"
        (click)="less(product.multiplo)">-</a>

      <div class="quantity-input-box flex-grow-1">
        <input
          [value]="quantity"
          type="number"
          (keyup)="setQuantity($event)"
          (keyup.enter)="addCart()"
          class="form-control quantity-input {{ inputClass }}"
          min="0" />
      </div>

      <a class="noselect quantity-button-plus {{ inputClass }}"
        (click)="plus(product.multiplo)">+</a>
    </div>

    <div class="ml-2 d-flex justify-content-end">
      <button
        (click)="addCart()"
        class="btn confirm-button"
        type="button">
        <i class="{{ SITE ? SITE.iconCart : ''}}"></i>
      </button>
    </div>
  </div>

  <!-- QUANDO NÃO TEM SKU -->
  <ng-template #semSku>
    <div class="mt-1 mb-1" [style.padding]="'0 10%'">
      <button
        class="btn btn-comprar d-flex align-items-center justify-content-center"
        (click)="redirectTo.emit(product.id)" [style.width]="'90%'" [style.color]="'white'" [style.backgroundColor]="SITE.backgroundColorSliderSuperior">
        
        <i class="{{ SITE ? SITE.iconCart : ''}}" style="margin-right: 8px;"></i>
        Comprar
      </button>
    </div>
  </ng-template>

</div>